export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  DEFAULT: 'default',
  GHOST: 'ghost',
  LINK: 'link'
} as const
